import { PlanENT } from '../../../types/models/plans/plans.types';
import { PLANS_ENDPOINTS } from '../../../utils/api/endpoints/plansEndpoints';

const PREFIX = '[allPlansENTQuery]';

export const queryAllPlansENT = async () => {
  console.log(PREFIX, `Fetching all Plans ENT...`);
  const response = await PLANS_ENDPOINTS.allENT();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received all Plans ENT.`);
  return json as PlanENT[];
};
